import Box from '@sendsprint/ui-react/dist/components/Box/Box';
import Icon from '@sendsprint/ui-react/dist/components/Icon/Icon';
import Text from '@sendsprint/ui-react/dist/components/Text/Text';
import CloseCircleOutline from '@sendsprint/ui-react/dist/icons/CloseCircleOutline';
import InfoOutline from '@sendsprint/ui-react/dist/icons/InfoOutline';
import { useDashboardContext } from '@src/contexts';
import React from 'react';

const ComplianceReview = () => {
  const { businessStatus } = useDashboardContext();

  //   None = 0, Pending = 1, Verified = 2, Failed = 3
  const isPending = businessStatus === 1;
  const isFailed = businessStatus === 3;

  const showInfo = isPending || isFailed;

  if (!showInfo) return null;

  return (
    <>
      {isPending && (
        <Box className="ss-bg-warning-50 ss-py-4 ss-w-full lg:ss-flex-1 ss-relative">
          <Box className="ss-absolute ss-bg-warning-50 ss--left-8 ss-w-full ss-top-0 ss-h-full" />
          <Box className="ss-relative ss-flex ss-items-center ss-gap-3">
            <Icon svg={InfoOutline} className="ss-text-warning-500" size={24} />
            <Text className="ss-font-medium">
              Your application is undergoing reviews from our compliance team
            </Text>
          </Box>
        </Box>
      )}

      {isFailed && (
        <Box className="ss-bg-error-50 ss-py-4 ss-w-full lg:ss-flex-1 ss-relative">
          <Box className="ss-absolute ss-bg-error-50 ss--left-8 ss-w-full ss-top-0 ss-h-full" />
          <Box className="ss-relative ss-flex ss-items-center ss-gap-3">
            <Icon svg={CloseCircleOutline} className="ss-text-error-500" size={24} />
            <Text className="ss-font-medium">
              Your application was unsuccessful. Review and send again.
            </Text>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ComplianceReview;
